import {useEffect, useState} from 'react';

interface FeatureFlags {
  [key: string]: boolean;
}

const STORAGE_KEY = 'feature_flags';

export enum FeatureFlag {
  RESIDUALS_HISTORY = 'residualsHistory',
}

export const useFeatureFlag = (featureKey: FeatureFlag) => {
  const [isEnabled, setIsEnabled] = useState<boolean>(false);

  //TODO: add feature flag collection to firebase, local storage flags should take precedence over firebase flags for testing
  // Load initial state from localStorage
  useEffect(() => {
    try {
      const storedFlags = localStorage.getItem(STORAGE_KEY);
      if (storedFlags) {
        const flags: FeatureFlags = JSON.parse(storedFlags);
        setIsEnabled(flags[featureKey] ?? false);
      }
    } catch (error) {
      console.error('Error reading feature flags from localStorage:', error);
    }
  }, [featureKey]);

  return isEnabled;
};
